import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RemoteConfigService } from '@app/core/firebase/remote-config/remote-config.service';
import { TranslocoMissingHandlerController } from '@app/core/transloco/transloco-module.loader';
import { NavigationAction } from 'app/core/navigation/navigation.action';
import { forkJoin, from, take } from 'rxjs';

export const initialDataResolver = (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const navigationActions = inject(NavigationAction);
  const remoteConfigService = inject(RemoteConfigService);
  const translocoController = inject(TranslocoMissingHandlerController);
  const lang = localStorage.getItem('webLanguage') ?? 'en';

  remoteConfigService.refreshFirebaseRemoteConfig();
  navigationActions.actions?.get();
  const module = (state.url ?? '/database/company').split('/').filter((w) => !!w)[0];

  return forkJoin([navigationActions.actions.getSuccess$.pipe(take(1)), from(translocoController.loadByModule(lang, module))]);
};
